/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LinkType {
	Xyicon = 0,
	Boundary = 3,
}
